class ThemeFilters extends HTMLElement {
  constructor() {
    super();
  }
}
class ThemeToggle extends HTMLElement {
  constructor() {
    super();
  }
}
class ThemeGroup extends HTMLElement {
  constructor() {
    super();
  }
}

class FilterDropdown extends HTMLElement {
  constructor() {
    super();
    this.querySelector("filter-toggle").addEventListener("click", () => this.toggle());
  }

  toggle = () => {
    const current = this.querySelector("filter-group");

    // // Hide all open groups
    // document
    //   .querySelector("theme-filters")
    //   .querySelectorAll("filter-group")
    //   .forEach(filter => {
    //     if (filter != current) {
    //       filter.classList.add("hidden");
    //     }
    //   });

    // Show current group
    current.classList.toggle("hidden");
  };
}

customElements.define("theme-filters", ThemeFilters, { extends: "div" });
customElements.define("filter-toggle", ThemeToggle, { extends: "button" });
customElements.define("filter-group", ThemeGroup, { extends: "div" });
customElements.define("filter-dropdown", FilterDropdown);
